/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TreeNode {
  children?: any;
  id: number;
  name: string;
  parentId: number | null;
  actionTypeId: number;
  data: any;
  side?: string;
  position?: { x: number; y: number }
}

interface TreeState {
  nodes: TreeNode[];
  nextId: number;
  actionTrigger: string;
  saveResponseVariable: string,
  type: number;
  payload?: {
    key: string,
    value: string
  }[];
  channel?: string;
  channelContent?: string[];
  targetMode?: number
  userName?: number
  userNameContent?: string[]
}

const initialState: TreeState = {
  nodes: [],
  nextId: 1000, // ID tự tăng
  actionTrigger: '',
  saveResponseVariable: '',
  type: 0,
  payload: [{ key: '', value: '' }],
  channel: undefined,
  channelContent: undefined,
  targetMode: undefined,
  userName: undefined,
  userNameContent: undefined,
};

export const actionSlice = createSlice({
  name: 'authReducer',
  initialState,
  reducers: {
    addNode(
      state,
      action: PayloadAction<{ node: TreeNode | null; side?: string }>
    ) {
      state.nodes.push({
        id: state.nodes?.length > 0 ? state.nodes[state.nodes.length - 1]?.id + 1 : state.nextId,
        name: `node${state.nextId}`,
        parentId: action.payload.node ? action.payload.node.id : null,
        actionTypeId: 0,
        data: null,
        side: action.payload?.side || '',
        position: action.payload.node?.position
      });
      state.nextId += 1;
    },
    updateNode(state, action: PayloadAction<TreeNode>) {
      const index = state.nodes.findIndex((n) => n.id === action.payload.id);
      if (index !== -1) {
        state.nodes[index] = action.payload;
      }
    },
    deleteNode(state, action: PayloadAction<number>) {
      const visited = new Set<number>();
      const deleteRecursive = (id: number) => {
        if (visited.has(id)) return; // chặn lặp
        visited.add(id);

        const children = state.nodes.filter((n) => n.parentId === id);
        children.forEach((child) => deleteRecursive(child.id));

        state.nodes = state.nodes.filter((n) => n.id !== id);
      };

      deleteRecursive(action.payload);
    },
    setTrigger(state, action: PayloadAction<string>) {
      state.actionTrigger = action.payload;
    },

    setVariable(state, action: PayloadAction<string>) {
      state.saveResponseVariable = action.payload;
    },

    setTypeTrigger(state, action: PayloadAction<number>) {
      state.type = action.payload;
    },

    setPayloadTrigger(state, action: PayloadAction<Array<{ key: string; value: string }>>) {
      state.payload = action.payload;
    },

    setChannel(state, action: PayloadAction<string>) {
      state.channel = action.payload;
    },

    setChannelContent(state, action: PayloadAction<string[]>) {
      state.channelContent = action.payload;
    },

    setTargetMode(state, action: PayloadAction<number | undefined>) {
      state.targetMode = action.payload;
    },

    setUserName(state, action: PayloadAction<number | undefined>) {
      state.userName = action.payload;
    },

    setUserNameContent(state, action: PayloadAction<string[]>) {
      state.userNameContent = action.payload;
    },

    setTreeNode(state, action: PayloadAction<TreeNode[]>) {
      state.nodes = action.payload;
    },

    duplicateNode(state, action: PayloadAction<TreeNode>) {
      state.nodes.push({
        id: state.nodes?.length > 0 ? state.nodes[state.nodes.length - 1]?.id + 1 : state.nextId,
        name: `node${state.nextId}`,
        actionTypeId: action.payload.actionTypeId,
        data: action.payload.data,
        parentId: null
      });
      state.nextId += 1;
    },
  },
});

export const {
  setPayloadTrigger,
  setTypeTrigger, setChannel, setChannelContent, setTargetMode, setUserName, setUserNameContent,
  addNode, updateNode, deleteNode, setTrigger, setTreeNode, setVariable, duplicateNode
} = actionSlice.actions;

export default actionSlice.reducer;
